import type { AboutNewsroomContent } from '../types/AboutNewsroomContent';

export function createAboutNewsroomContentPlaceholder(): AboutNewsroomContent {
    return {
        pageTitle: { kind: 'plainText', key: '', content: '' },
        pageSubtitle: { kind: 'plainMultilineText', key: '', content: '' },
        pageTitleBackgroundImage: { kind: 'image', key: '', imageUrl: '' },
    };
}
